import React from 'react';
import PropTypes from 'prop-types';
// shared
import { Alert } from 'components/library';
import { LoaderButton } from 'shared';
import { LocaleString } from '@biw/intl';


class OnTheSpotComponent extends React.Component {

    state = {
        code: ''
    }

    componentDidMount() {
        if ( !this.props.removeDefaultStyles ) {
            require( './on-the-spot.scss' );
        }
        if ( this.props.requireCustomStyles ) {
            this.props.requireCustomStyles();
        }
    }

    componentWillUnmount() {
        const { success, error } = this.props;
        if ( success === true ) {
            this.dismissSuccess();
        } else if ( error && error.message ) {
            this.dismissError();
        }
    }

    submitCode = () => {
        const { redeem, userName } = this.props;
        const { code } = this.state;
        this.dismissError();

        redeem( { code, userName } );
    };

    handleInputChange = ( event ) => {
        const name = event.target.name;
        this.setState( { [ name ]: event.target.value } );

        this.dismissSuccess();
    };

    dismissError = () => {
        if ( this.props.error ) {
            this.props.dismissError();
        }
    }

    dismissSuccess = () => {
        if ( this.props.successMessage ) {
            this.props.setMessage( 'success', false );
        }
        if ( this.props.success ) {
            this.props.setSuccess( false );
        }
    }

    render () {
        const { code } = this.state;
        const {
            success,
            successMessage,
            error,
            tabIndex,
            busy,
            mediaLabel,
            cardPlaceholder,
            disable
        } = this.props;

        return (
            <div className="on-the-spot">
                <div className="on-the-spot-description">
                    <label htmlFor="onTheSpot">
                        <h3 className="on-the-spot-description-header">
                            <LocaleString code="ots.content.title" />
                        </h3>
                    </label>
                    <p className="on-the-spot-description-paragraph">
                        <LocaleString code="ots.content.instructions" />
                    </p>
                </div>
                <div className="on-the-spot-input">
                    <div className="on-the-spot-form-group form-group">
                        <input
                            id="onTheSpot"
                            className="on-the-spot-input-control"
                            type="text"
                            name="code"
                            value={ code }
                            tabIndex={ tabIndex }
                            required={ false }
                            onChange={ this.handleInputChange }
                            disabled = { busy }
                            placeholder={ cardPlaceholder }
                        />

                        <LoaderButton
                            fetching={ busy }
                            handleClick={ this.submitCode }
                            disabled={ !code || success || disable }
                            tabIndex={ tabIndex ? tabIndex + 1 : undefined }
                            done={ success }
                            branding>
                            <LocaleString code="ots.button.submitLabel" />
                        </LoaderButton>

                    </div>

                    {
                        error && error.message
                        &&
                        <Alert className="on-the-spot-alert-error" type="error" onDismiss={ () => this.props.dismissError() }>
                            <p><LocaleString code={ error.message } replaceOptions={ { mediaLabel } } /></p>
                        </Alert>
                    }

                    {
                        successMessage
                        &&
                        <Alert className="on-the-spot-alert-success" type="success" onDismiss={ () => this.props.setMessage( 'success', false ) }>
                            <p>
                                <LocaleString code={ successMessage.cmText }
                                    replaceOptions={ { mediaLabel, numberOfPoints: successMessage.points } } />
                            </p>
                        </Alert>
                    }

                </div>
            </div>
        );
    }
}
export default OnTheSpotComponent;
OnTheSpotComponent.propTypes = {
    dismissError: PropTypes.func.isRequired,
    error: PropTypes.oneOfType( [
        PropTypes.shape( { message: PropTypes.string } ),
        PropTypes.string,
        PropTypes.bool
    ] ),
    redeem: PropTypes.func.isRequired,
    removeDefaultStyles: PropTypes.bool,
    requireCustomStyles: PropTypes.func,
    setMessage: PropTypes.func.isRequired,
    setSuccess: PropTypes.func.isRequired,
    successMessage: PropTypes.oneOfType( [
        PropTypes.object,
        PropTypes.bool
    ] ),
    success: PropTypes.bool.isRequired,
    userName: PropTypes.string,

    tabIndex: PropTypes.number,
    busy: PropTypes.bool,
    mediaLabel: PropTypes.string,
    cardPlaceholder: PropTypes.string,
    disable: PropTypes.bool,
};

